export default "__VITE_ASSET__BRKOshEX__"